// ABOUTME: Modal shell hosting the bulk (multi-entity) export and import panels, toggled by tabs.
import {Close} from '@mui/icons-material'
import {Box, Dialog, DialogContent, DialogTitle, IconButton, Tab, Tabs} from '@mui/material'
import React, {useState} from 'react'

import {BulkExportPanel} from './BulkExportPanel'
import {BulkImportPanel} from './BulkImportPanel'
import {useTranslation} from '../../../../hooks/useTranslation'
import {useBulkEntities} from '../hooks/useConfigImportExport'
import {Entity} from '../types'

interface BulkImportExportModalProps {
  open: boolean
  onClose: () => void
  entities: Entity[]
  countryId: string
  businessLine: string
}

export const BulkImportExportModal: React.FC<BulkImportExportModalProps> = ({
  open,
  onClose,
  entities,
  countryId,
  businessLine
}) => {
  const {t} = useTranslation()
  const {data: supportedKeys} = useBulkEntities()
  const [tab, setTab] = useState<'export' | 'import'>('export')

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        <DialogTitle>{t('countryConfigurations.importExport.bulk.title')}</DialogTitle>
        <IconButton onClick={onClose} sx={{mr: 1}} aria-label={t('countryConfigurations.importExport.importDialog.close')}>
          <Close />
        </IconButton>
      </Box>

      <Tabs value={tab} onChange={(_, value) => setTab(value as 'export' | 'import')} sx={{px: 3}}>
        <Tab value="export" label={t('countryConfigurations.importExport.bulk.tabExport')} />
        <Tab value="import" label={t('countryConfigurations.importExport.bulk.tabImport')} />
      </Tabs>

      <DialogContent dividers>
        {tab === 'export' ? (
          <BulkExportPanel
            entities={entities}
            supportedKeys={supportedKeys ?? []}
            countryId={countryId}
            businessLine={businessLine}
            onClose={onClose}
          />
        ) : (
          <BulkImportPanel countryId={countryId} businessLine={businessLine} />
        )}
      </DialogContent>
    </Dialog>
  )
}
